import React from 'react';
import * as css from './LecturersDisplay.css';
import {teamMemberPhoto} from '../../../../../assets/symbols/images/teamMemberPhoto';
import {TTimetableLecturer} from '../../../../../redux/timetable/timetable.type';
import {sortLecturers} from '../../../../../library/sortLecturers';

const MAX_AVATARS = 4;

interface LecturersDisplayProps {
    lecturers: TTimetableLecturer[];
    isBreak?: boolean;
}

function LecturersDisplay({lecturers, isBreak}: LecturersDisplayProps) {
    if(isBreak || lecturers.length === 0) {
        return <css.lecturersPlaceholder />;
    }

    const sorted = sortLecturers(lecturers);

    if(sorted.length === 1) {
        return (
            <css.lecturerRow>
                <css.avatar $image={sorted[0].image || teamMemberPhoto} />
                <css.lecturerName dir="auto">
                    {sorted[0].firstName} {sorted[0].lastName}
                </css.lecturerName>
            </css.lecturerRow>
        );
    }

    const visibleAvatars = sorted.slice(0, MAX_AVATARS);
    const overflowCount = Math.max(0, sorted.length - MAX_AVATARS);

    return (
        <css.avatarsRow>
            {visibleAvatars.map(l => <css.avatar key={l.lid} $image={l.image || teamMemberPhoto} />)}
            {overflowCount > 0 && <css.overflowBadge>+{overflowCount}</css.overflowBadge>}
        </css.avatarsRow>
    );
}

export default LecturersDisplay;
